package com.exura.features.newauth.domain.model

enum class UserRole(val id: String) {
    //Providers

    DOCTOR("doctor"),
    ORGANIZATION("organization"),
    STAFF("staff"),

    //Receivers

    ANONYMOUS("anonymous"),
    RECEIVER("receiver");
}
